<template>
  <div>
    <q-table
      v-if="!add_game_screen"
      :data="games"
      :columns="columns"
      :pagination.sync="server_pagination"
      @request="request"
      :loading="loading"
      row-key="id"
      :no-data-label="$t('no_data_avaliable')"
      :no-results-label="$t('no_results_found')"
      :loading-label="$t('loading_data')"
      :rows-per-page-label="$t('items_per_page')"
      :rows-per-page-options="[0]"
      binary-state-sort
      class="q-mt-md"
    >
      <template slot="top" slot-scope="props" :props="props">
        <div class="col" />
        <q-btn
          color="secondary"
          icon="fas fa-plus"
          :label="$t('new')"
          @click="showGame(0)"
          :disable="!managerTrainings"
        />
      </template>

      <q-tr slot="header" slot-scope="props" :props="props">
        <q-th v-for="col in props.cols" :key="col.name" :props="props">
          {{ $t(col.label) }}
        </q-th>
      </q-tr>

      <q-tr slot="body" slot-scope="props" :props="props">
        <q-td auto-width key="id" :props="props">
          {{ props.row.id }}
        </q-td>

        <q-td key="title" :props="props">
          {{ props.row.title }}
        </q-td>

        <q-td key="game_type" :props="props">
          {{ $t(getGameType(props.row.game_type)) }}
        </q-td>

        <q-td auto-width key="status" :props="props">
          <q-chip
            small
            :icon="getIconStatus(props.row.status)"
            :color="getColorStatus(props.row.status)"
            class="full-width"
          >
            {{ $t(getStatus(props.row.status)) }}
          </q-chip>
        </q-td>

        <q-td key="avaliable_in" :props="props">
          {{ props.row.avaliable_in }}
        </q-td>

        <q-td key="score" :props="props">
          {{ props.row.score }}
        </q-td>

        <q-td key="actions" :props="props">
          <q-btn
            flat
            round
            color="primary"
            icon="fas fa-pencil-alt"
            @click="showGame(props.row.actions)"
            :disable="!managerTrainings"
          >
            <q-tooltip>
              {{ $t('view_or_edit_tooltip') }}
            </q-tooltip>
          </q-btn>

          <q-btn
            flat
            round
            color="negative"
            icon="far fa-trash-alt"
            @click="confirmRemove(props.row.actions)"
            :disable="!managerTrainings"
          >
            <q-tooltip>
              {{ $t('delete_tooltip') }}
            </q-tooltip>
          </q-btn>
        </q-td>
      </q-tr>
    </q-table>

    <div class="row gutter-sm justify-end q-mt-lg" v-if="!add_game_screen">
      <div class="col-xs-12 col-sm-3">
        <q-btn
          color="tertiary"
          class="full-width"
          :label="$t('back')"
          icon="fas fa-chevron-left"
          @click="$router.push({ name: 'admin_trainings' })"
        />
      </div>
    </div>

    <new-game
      v-if="add_game_screen"
      :add_game_screen="add_game_screen"
      :id_training="id_training"
      :id_game="id_game"
      @returnToGames="returnToGames()"
      @changeIdGame="changeIdGame"
    />

    <q-dialog v-model="confirm_remove" @ok="removeGame()">
      <span slot="title">{{ $t('remove_item') }}</span>

      <span slot="message">{{ $t('confirm_remove_item') }}</span>

      <template slot="buttons" slot-scope="props" :props="props">
        <q-btn color="primary" :label="$t('cancel')" @click="confirm_remove = false" />
        <q-btn color="negative" :label="$t('remove')" @click="removeGame()" />
      </template>
    </q-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { date } from 'quasar'
const { formatDate } = date
import * as moment from 'moment'
import * as tz from 'moment-timezone'

export default {
  i18nOptions: { namespaces: ['custom', 'common', 'training', 'admin', 'games'] },

  props: ['managerTrainings'],

  data() {
    return {
      id_training: '',
      id_game: '',
      server_pagination: {
        page: 1,
        rowsNumber: 10,
        rowsPerPage: 0,
        descending: false,
        sortBy: null,
      },
      games: [],
      columns: [
        {
          name: 'id',
          required: true,
          label: '#',
          align: 'left',
          field: 'id',
          sortable: true,
        },
        {
          name: 'title',
          required: true,
          label: 'title',
          align: 'left',
          field: 'title',
          sortable: true,
        },
        {
          name: 'game_type',
          required: true,
          label: 'game_type',
          align: 'left',
          field: 'game_type',
          sortable: true,
        },
        {
          name: 'status',
          required: true,
          label: 'status',
          align: 'left',
          field: 'status',
          sortable: true,
        },
        {
          name: 'avaliable_in',
          required: true,
          label: 'avaliable_in',
          align: 'left',
          field: 'avaliable_in',
          sortable: true,
        },
        {
          name: 'score',
          required: true,
          label: 'score',
          align: 'left',
          field: 'score',
          sortable: true,
        },
        {
          name: 'actions',
          required: true,
          label: '',
          align: 'right',
          field: 'edit',
          sortable: false,
        },
      ],
      loading: false,
      add_game_screen: false,
      action_id: '',
      confirm_remove: false,
    }
  },

  components: {
    'new-game': () => import('components/admin/games/NewGame'),
  },

  computed: {
    ...mapGetters({
      access_token: 'common/access_token',
      group_training_game_types: 'registration_lists/group_training_game_types',
    }),

    getHeader() {
      return {
        headers: {
          'content-type': 'application/json',
          authorization:
            'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
          authorization: 'Bearer ' + this.access_token,
        },
      }
    },
  },

  methods: {
    request({ pagination }) {
      this.loading = true
      this.server_pagination = pagination

      let order = pagination.descending ? '-' : ''
      let order_by = pagination.sortBy ? order + pagination.sortBy : ''

      let data = {
        page_size: this.server_pagination.rowsPerPage,
        page: this.server_pagination.page,
        search: this.filter,
        ordering: order_by,
      }

      this.$axios
        .get(
          `/admin_group_trainings/group_trainings/${
            this.id_training
          }/group_training_games/?${this.$qs.stringify(data)}`,
          this.getHeader
        )
        .then((response) => {
          this.server_pagination.rowsNumber = response.data.count

          this.games = response.data.results.map((e) => {
            return {
              ...e,
              game_type: e.group_training_game_type,
              actions: e.id,
            }
          })

          this.loading = false
        })
        .catch((e) => {
          this.loading = false
          console.log(e)
        })
    },

    confirmRemove(id) {
      this.action_id = id
      this.confirm_remove = true
    },

    removeGame() {
      this.$q.loading.show()

      this.$axios
        .delete(
          `/admin_group_trainings/group_trainings/${this.id_training}/group_training_games/${
            this.action_id
          }/`,
          this.getHeader
        )
        .then((response) => {
          this.$q.loading.hide()

          this.request({
            pagination: this.server_pagination,
          })

          this.confirm_remove = false

          this.$q.notify({
            message: this.$t('item_removed_success'),
            type: 'positive',
            icon: 'far fa-trash-alt',
          })
        })
        .catch((e) => {
          this.$q.loading.hide()
          console.log(e)
        })
    },

    showGame(id) {
      this.id_game = id
      this.add_game_screen = true
    },

    getGameType(id) {
      let obj = this.group_training_game_types.find((obj) => obj.id === id)
      if (obj) return this.$t(obj.slug)
      else return ''
    },

    getStatus(status) {
      if (status == 1) return 'published'
      else if (status == 2) return 'unpublished'
      else if (status == 3) return 'deleted'
    },

    getIconStatus(status) {
      if (status == 1) return 'fas fa-check'
      else if (status == 2) return 'fas fa-ban'
      else if (status == 3) return 'fas fa-trash-alt'
    },

    getColorStatus(status) {
      if (status == 1) return 'positive'
      else if (status == 2) return 'warning'
      else if (status == 3) return 'negative'
    },

    changeIdGame(id) {
      this.id_game = id
    },

    returnToGames() {
      window.scrollTo(0, 0)

      this.request({
        pagination: this.server_pagination,
      })

      this.id_game = ''
      this.add_game_screen = false
    },
  },

  created() {
    this.id_training = this.$route.params.id

    this.request({
      pagination: this.server_pagination,
    })
  },
}
</script>

<style></style>
